<div class="header-parent-title">
  <div class="header-child-title">Create an Apple Showcase</div>
  <div class="header-child-title">.</div>
</div>

<app-progress #progress (stateChange)="onStateChange($event)" [stepsLabels]="stepsLabels">
  <app-progress-step [formGroup]="eventForm">
    <app-abp-date-locations-form [displayScheduleLaterSwitch]="true" [scheduleGroup]="scheduleGroup" [rows]="2"
      [width]="'87vw'"></app-abp-date-locations-form>
    <app-post-info [postInfoGroup]="postInfoGroup" [closeAbpUtmFormEvent]="closeAbpUtmFormEvent"
      [scheduleGroup]="scheduleGroup">
    </app-post-info>
  </app-progress-step>
  <app-progress-step>
    <app-abp-image-upload
      [formControl]="imageUrlControl"
      [label]="'Upload Photo'"
      [requirements]="photoRequirements"
      [requirementsTitle]="photoRequirementsTitle"
      (imageSelected)="onImageSelected($event)"
      (imageCleared)="onImageCleared()">
    </app-abp-image-upload>
    <div *ngIf="isImageUploading" class="upload-status" style="margin-top: 10px; text-align: center;">
      <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="2" fill="var(--surface-ground)"></p-progressSpinner>
      <p style="margin-top: 10px;">Uploading image to server...</p>
    </div>
    <!-- <div *ngIf="!type" class="event-info-row">
      <div class="event-info-title">
        Alt Text&#x2a;
      </div>
      <div class="event-info-input">
        <input class="event-info-field" maxlength="58" type="text" pInputText formControlName="title"
          placeholder="Type Here..." />
        <span class="charac_limit">0 / 58</span>
      </div>
      <br />
    </div> -->
    <!-- <div class="event-info-row">
      <div class="event-info-title">Language&#x2a;</div>
      <div class="event-info-input">
        <p-dropdown [options]="languages" appendTo="body" formControlName="languageCode"
          placeholder="Select Language..." [style]="{ flex: '1' }"></p-dropdown>
      </div>
    </div> -->
  <div *ngFor="let contentGroup of imageLanguages.controls; let i = index" class="language-block">
      <div class="language-block-header" *ngIf="imageLanguages.length > 1">
        <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-danger"
          (click)="removeImageLanguage(i)" pTooltip="Remove" tooltipPosition="top"></button>
      </div>

      <div class="language-fields">
        <!-- Heading -->
        <!-- <div class="event-info-row">
          <div class="event-info-title">Heading&#x2a;</div>
          <div class="event-info-input">
            <input pInputText class="event-info-field" maxlength="38" type="text"
              [formControl]="contentGroup.get('heading')" placeholder="Type Here..." />
            <span class="charac_limit">
              {{ (contentGroup.get('heading')?.value?.length || 0) }} / 38
            </span>
          </div>
        </div> -->

        <!-- Alt Text -->
        <div class="event-info-row">
          <div class="event-info-title">Alt Text&#x2a;</div>
          <div class="event-info-input">
            <input pInputText class="event-info-field" maxlength="100" type="text"
              [formControl]="contentGroup.get('altText')" placeholder="Type Here..." />
            <span class="charac_limit">
              {{ (contentGroup.get('altText')?.value?.length || 0) }} / 100
            </span>
          </div>
        </div>

        <div class="event-info-row">
          <div class="event-info-title">Language&#x2a;</div>
          <div class="event-info-input">
            <p-dropdown [options]="languages" appendTo="body" 
              [formControl]="contentGroup.get('languageCode')"
              placeholder="Select Language..." [style]="{ flex: '1' }"></p-dropdown>
          </div>
        </div>
      </div>
    </div>
    <button pButton type="button" label="Add Image Language" class="p-button-secondary" (click)="addImageLanguage()"
      [style]="{ minWidth: 'auto' }"></button>
  </app-progress-step>
  <app-progress-step>
    <!-- This step can be used for other content if needed -->
    <!-- Dynamic Language Content Pairs -->
    <div *ngFor="let contentGroup of contentLanguages.controls; let i = index" class="language-block">
      <div class="language-block-header" *ngIf="contentLanguages.length > 1">
        <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-danger"
          (click)="removeContentLanguage(i)" pTooltip="Remove" tooltipPosition="top"></button>
      </div>

      <div class="language-fields">
        <!-- Heading -->
        <div class="event-info-row">
          <div class="event-info-title">Heading&#x2a;</div>
          <div class="event-info-input">
            <input pInputText class="event-info-field" maxlength="38" type="text"
              [formControl]="contentGroup.get('heading')" placeholder="Type Here..." />
            <span class="charac_limit">
              {{ (contentGroup.get('heading')?.value?.length || 0) }} / 38
            </span>
          </div>
        </div>

        <!-- Body Text -->
        <div class="event-info-row">
          <div class="event-info-title">Body Text&#x2a;</div>
          <div class="event-info-input">
            <input pInputText class="event-info-field" maxlength="100" type="text"
              [formControl]="contentGroup.get('bodyText')" placeholder="Type Here..." />
            <span class="charac_limit">
              {{ (contentGroup.get('bodyText')?.value?.length || 0) }} / 100
            </span>
          </div>
        </div>

        <div class="event-info-row">
          <div class="event-info-title">Language&#x2a;</div>
          <div class="event-info-input">
            <p-dropdown [options]="languages" appendTo="body" 
              [formControl]="contentGroup.get('languageCode')"
              placeholder="Select Language..." [style]="{ flex: '1' }"></p-dropdown>
          </div>
        </div>
      </div>
    </div>

    <button pButton type="button" label="Add Language" class="p-button-secondary" (click)="addContentLanguage()"
      [style]="{ minWidth: 'auto' }"></button>
  </app-progress-step>
  <app-progress-step>
    <app-submit *ngIf="activeIndex === 3" [form]="eventForm"
      [preSelectedLocs]="preSelectedLocation.length"></app-submit>
  </app-progress-step>
</app-progress>

<div class="bottom-buttons">
  <button *ngIf="activeIndex > 0" pButton label="BACK" class="p-button-outlined" progressStepPrev></button>
  <!-- <button *ngIf="activeIndex < 3" pButton label="NEXT" class="p-button-primary" (click)="goNext(progress)"></button> -->
  <button *ngIf="activeIndex < 3" pButton label="NEXT" class="p-button-primary" [disabled]="!isCurrentStepValid" (click)="goNext(progress)"></button>
  <button *ngIf="activeIndex === 3" pButton [label]="submitLoading ? 'Loading...' : 'SUBMIT'" class="p-button-primary" [disabled]="submitLoading" (click)="goNext(progress)"></button>
</div>
